import {Base} from "@/api/Base"

export class PaymentListExtraOverrideByIdAdv extends Base {
    path = "payment/listExtraOverrideByIdAdv"
}